import { useState, useEffect, useRef } from 'react';
import { apiHolder as api } from 'api';
const storageApi = api.api.getDataStoreApi();
export const getStateFromLocalStorage = (stateName) => {
    var _a;
    try {
        const serializedState = (_a = storageApi.getSync(stateName)) === null || _a === void 0 ? void 0 : _a.data;
        if (serializedState) {
            return JSON.parse(serializedState);
        }
        return null;
    }
    catch (err) {
        console.error(`[ Hook Error useUserLocalStorageState ]Error getting state ${stateName} from localStorage:`, err);
        return null;
    }
};
const useUserLocalStorageState = (stateName, initialState) => {
    const [state, setState] = useState(() => {
        let localState = getStateFromLocalStorage(stateName);
        return localState != null ? localState : initialState;
    });
    const isInit = useRef(false);
    useEffect(() => {
        if (isInit.current) {
            try {
                const serializedState = JSON.stringify(state);
                storageApi.putSync(stateName, serializedState);
            }
            catch (err) {
                console.error(`Error setting state ${stateName} to localStorage: ${err}`);
            }
        }
        isInit.current = true;
    }, [state, stateName]);
    return [state, setState];
};
export default useUserLocalStorageState;
